import { Controller } from "stimulus";
import { createPopper } from '@popperjs/core';

export default class extends Controller {
  static targets = ['anchor', 'message'];

  show() {
    this.popper = createPopper(this.anchorTarget, this.messageTarget, {
      modifiers: [{
        name: 'offset',
        options: { offset: [10, 10] }
      }, {
        name: 'arrow',
      }]
    });

    this.messageTarget.classList.add('opacity-90');
  }

  hide() {
    this.messageTarget.classList.remove('opacity-90');
  }
}
